const codes = [
  '#C33940', '#E73C3F', '#EF825B', '#F1A73B',
  '#FFC022', '#FFDC00', '#65F596', '#00BB3F',
  '#29BB9C', '#5EC5C8', '#1EAAF1', '#0B6DC4',
  '#5D4E89', '#A44FBF', '#CA52A0', '#EA3796'
]

const names = [
  'oeamtc-gradient__reddish', 'oeamtc-gradient__tomato', 'oeamtc-gradient__peach', 'oeamtc-gradient__cheese',
  'oeamtc-gradient__sunflower', 'oeamtc-gradient__yellow', 'oeamtc-gradient__mint', 'oeamtc-gradient__shamrock',
  'oeamtc-gradient__tealish', 'oeamtc-gradient__seafoam', 'oeamtc-gradient__azure', 'oeamtc-gradient__aquamarine',
  'oeamtc-gradient__twilight', 'oeamtc-gradient__amethyst', 'oeamtc-gradient__pink', 'oeamtc-gradient__barbie'
]

function codeToName (code: string) {
  return names[codes.indexOf(code.toUpperCase())]
}

function nameToCode (name: string) {
  return codes[names.indexOf(name)]
}

export default { codes, names, codeToName, nameToCode }
